import React from 'react'

import { bemJoin } from 'bem-join'
import classnames from 'classnames'

import './CheckIcon.scss'

enum IconSizes {
  small = 'small',
  standard = 'standard',
  medium = 'medium',
  large = 'large'
}

interface CheckIconProps {
  size?: IconSizes
}

const b = bemJoin('check-icon')

export const CheckIcon = ({ size = IconSizes.standard }: CheckIconProps) => (
  <div className={classnames(b({ [size]: true }))}>
    <svg
      className={b('svg')}
      data-name='Layer 1'
      width='100%'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 193.3 193.3'
    >
      <polyline
        stroke='green'
        strokeDasharray='150'
        fill='none'
        strokeWidth='18'
        points='46.9 101.4 76.9 131.4 146.4 61.9'
      >
        <animate
          attributeType='CSS'
          attributeName='stroke-dashoffset'
          from='150'
          to='0'
          dur='0.2s'
          repeatCount='1'
        />
      </polyline>
    </svg>
  </div>
)
